// CapacityGraph.jsx
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";

const data = [
  { name: "PV 5", min: 0, max: 250 },
  { name: "PV 8", min: 250, max: 500 },
  { name: "PV 10", min: 300, max: 600 },
  { name: "PV 20", min: 600, max: 1000 },
  { name: "PV 30", min: 1000, max: 1800 },
  { name: "PV 50", min: 800, max: 2500 },
  { name: "PV 60", min: 2000, max: 4000 },
  { name: "PV 90", min: 2000, max: 5000 },
  { name: "PV 120", min: 4000, max: 10000 },
  { name: "PV 180", min: 6000, max: 13000 },
  { name: "PV 270", min: 10000, max: 20000 },
];

// Transform data for stacked horizontal bars
const transformedData = data.map(item => ({
  name: item.name,
  start: item.min,
  capacity: item.max - item.min,
}));

const CapacityGraph = () => {
  return (
    <ResponsiveContainer width="100%" height={500}>
      <BarChart
        layout="vertical"
        data={transformedData}
        margin={{ top: 20, right: 50, left: 100, bottom: 20 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis type="number" label={{ value: "CAPACITY IN M³/hr", position: "bottom", offset: 0 }} />
        <YAxis dataKey="name" type="category" />
        <Tooltip />
        <Bar dataKey="start" stackId="a" fill="transparent" />
        <Bar dataKey="capacity" stackId="a" fill="#007bff" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default CapacityGraph;
